// Models
/** Extension fields for the copilot */ export class MarsPlannerCopilotPropertiesExtensions {
    constructor(copilotWorkflowState, copilotActivityTimestamp, reason){
        this.copilotWorkflowState = copilotWorkflowState;
        this.copilotActivityTimestamp = copilotActivityTimestamp;
        this.reason = reason;
    }
}
